import * as React from 'react';

function Icon() {
  return (
    <svg width={24} height={23} viewBox="0 0 24 23" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M22.08 10.671h-8.96V1.897A1.11 1.11 0 0012 .8c-.618 0-1.12.491-1.12 1.097v8.774H1.92A1.11 1.11 0 00.8 11.768a1.11 1.11 0 001.12 1.097h8.96v8.774c0 .606.502 1.097 1.12 1.097a1.11 1.11 0 001.12-1.097v-8.774h8.96a1.11 1.11 0 001.12-1.097 1.11 1.11 0 00-1.12-1.097z"
        fill="#FFBF17"
      />
    </svg>
  );
}

export default Icon;
